var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:_vm.verticalOrientationCheck},_vm._l((_vm.offers),function(offer,index){return _c('OffersCard',{key:offer.offerCode,attrs:{"offer":offer,"position":_vm.globalPosition + index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }